<template>
  <div id="Edit">
    <h2>服务管理</h2>
    <div class="EditTable">
      <!-- <div class="EditTable_AddBtn"> -->
      <!-- <el-button type="success"
          ><a
            href="http://www.youyihu.cn/#/#News"
            target="_blank"
            rel="noopener noreferrer"
            >返回新闻页面</a
          >
        </el-button> -->
      <!-- <el-button type="success" @click="$router.push({ path: '/#News' })"
          >查看新闻页面</el-button
        > -->
      <!-- <el-button type="primary" @click="openAddNewsDialog()">添加</el-button> -->
      <!-- </div> -->
      <!-- 表格 -->
      <div class="EditMain">
        <el-table :data="tableData" height="100%" border row-key="id">
          <el-table-column label="编号" prop="id" align="center" width="50">
          </el-table-column>
          <el-table-column label="服务名称" prop="serviceType" align="center">
          </el-table-column>
          <el-table-column
            label="当前内容"
            prop="servicePictureUrl"
            align="center"
          >
            <template slot-scope="scope">
              <el-button
                type="text"
                @click="open(scope.row.servicePictureUrl)"
                >{{ scope.row.servicePictureUrl }}</el-button
              >
            </template>
          </el-table-column>
          <el-table-column
            label="更新时间"
            prop="updateTime"
            width="250"
            align="center"
          >
          </el-table-column>
          <el-table-column label="编辑" width="180" align="center">
            <template slot-scope="scope">
              <el-button type="primary" @click="edit(scope.row)"
                >编辑</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-dialog
        title="修改服务"
        :visible.sync="dialogVisible"
        width="30%"
        center
      >
        <el-form :model="form">
          <div class="title">
            服务名称:
            {{ form.serviceType
            }}<span style="color: red">
              *仅允许上传一张图片,图片格式为jpg,png,gif,jpeg</span
            >
          </div>

          <el-upload
            class="upload-demo"
            action="#"
            :http-request="fileUpload"
            list-type="picture-card"
            accept="image/jpeg,image/gif,image/png,image/bmp"
            :on-change="fileChange"
            :file-list="fileList"
          >
            <i class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="submit">确 定</el-button>
        </div>
      </el-dialog>

      <!-- <div class="EditPagination">
        <el-pagination
          :hide-on-single-page="true"
          @current-change="handleCurrentChange"
          background
          layout="total,  prev, pager, next"
          :total="total"
        >
        </el-pagination>
      </div> -->
    </div>
  </div>
</template>
<script>
// import Sortable from "sortablejs";
import { getServiceList, upLoadService, editService } from "../axiosAPI";
export default {
  inject: ["reload"],
  name: "Edit",
  components: {},
  data() {
    return {
      // 表格数据
      tableData: [],
      limit: 5,
      page: 1,
      total: 0,
      // dialog
      dialogVisible: false,
      dialogTitle: "",
      dialogBtn: "",
      // 表单数据
      form: {},
      // 选择的类型
      type: "",
      url: "",
      fileList: [],
    };
  },
  mounted() {
    // 获取新闻
    this.getNews();
    // 验证token
    this.verifyToken();
  },
  methods: {
    // 获取新闻
    getNews() {
      let query = this.$qs.stringify({
        limit: this.limit,
        page: this.page,
      });
      getServiceList(query).then((res) => {
        if (res.data.code == 200) {
          this.total = res.data.item.count;
          this.tableData = res.data.item;
        } else {
          this.$router.push({ path: "/Login" });
          this.$message({
            type: "warning",
            message: "登录超时，请重新登录",
          });
        }
      });
    },
    // 分页回调
    handleCurrentChange(val) {
      this.page = val;
      this.getNews();
    },
    // 文件状态改变时的钩子
    fileChange(file, fileList) {
      this.file = file.raw;
      if (fileList.length > 0) {
        this.fileList = [fileList[fileList.length - 1]]; // 获取最后一次选择的文件
      }
    },
    // 上传服务图片
    fileUpload(file) {
      console.log(file, "file");
      console.log(this.fileList, "fileList");
      let formData = new FormData();
      formData.append("file", file.file);
      upLoadService(formData).then((res) => {
        if (res.data.code == 200) {
          this.url = res.data.item;
        } else {
          this.$router.push({ path: "/Login" });
          this.$message({
            type: "warning",
            message: "登录超时，请重新登录",
          });
        }
      });
    },
    open(url) {
      // window.location.href = url;
      window.open(url, "_blank");
    },
    edit(row) {
      this.form = row;
      this.dialogVisible = true;
      this.fileList = [];
    },
    submit() {
      let query = this.$qs.stringify({
        url: this.url,
        type: this.form.serviceType,
      });
      editService(query).then((res) => {
        if (res.data.code == 200) {
          this.dialogVisible = false;
          this.getNews();
        } else {
          this.$router.push({ path: "/Login" });
          this.$message({
            type: "warning",
            message: "登录超时，请重新登录",
          });
        }
      });
    },
    // 验证token 不允许直接访问
    verifyToken() {
      let axData = JSON.parse(sessionStorage.getItem("axData"));
      if (!axData) {
        this.$message({
          type: "warning",
          message: "请先登录",
        });
        this.$router.push({ path: "/Login" });
      }
    },
  },
};
</script>
<style lang="less" scoped>
#Edit {
  width: 90vw;
  height: 100vh;
  background-color: #f0f0f0;
  h2 {
    text-align: center;
    font-size: 0.425rem;
    line-height: 1.8rem;
  }
  .EditTable {
    width: 80%;
    height: 6.5rem;
    background-color: #fff;
    box-shadow: 0 0 10px #ccc;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    margin: auto;
    .EditTable_AddBtn {
      height: 1rem;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      margin: 0 0.5rem;
      a {
        text-decoration: none;
        color: #fff;
      }
    }
    .EditMain {
      height: 6rem;
    }
    .EditPagination {
      width: 100%;
      height: 0.5rem;
      display: flex;
      justify-content: center;
      margin-top: 0.28rem;
    }
  }
}
</style>
<style lang="less">
.el-icon-warning {
  font-size: 20px;
}
.el-icon-success {
  font-size: 20px;
}
.el-dialog {
  .el-dialog__header {
    display: flex;
    button {
      font-size: 0.3rem;
    }
  }
  .title {
    font-size: 18px;
    margin: 20px 0;
    span {
      font-size: 16px;
      margin-left: 10px;
    }
  }
}

.tox-tinymce-aux {
  z-index: 999999 !important;
}
</style>
